import { Navigate } from "react-router-dom"
import { useActivation } from "@/lib/activation-context"
import { useSession } from "@/lib/session-context"

export function totalStepsFor(workflowVersion) {
  return Number(workflowVersion) >= 2 ? 4 : 5
}

export function effectiveActivationStep(currentStep, step2, complete = false) {
  if (complete) return currentStep
  if (currentStep > 2 && !step2?.strategyLocked) return 2
  return currentStep
}

export function useDashboardGuard() {
  const { currentUser } = useSession()
  const { currentStep, step2, workflowVersion, complete, isHydrating } = useActivation()
  if (!currentUser) return <Navigate to="/" replace />
  if (isHydrating) return null
  const activationStep = effectiveActivationStep(currentStep, step2, complete)
  const totalSteps = totalStepsFor(workflowVersion)
  if (!complete && activationStep <= totalSteps) return <Navigate to={`/activation/step/${activationStep}`} replace />
  return null
}
